import { useMediaQuery } from "react-responsive";

export const useIsMobileScreen = (): boolean => {
  return useMediaQuery({ orientation: "portrait" });
};
